import React, { useState, Suspense } from 'react'
import { useMatch } from 'react-router'

import PrimaryNavigation from './Primary'
import SecondaryNavigation from './Secondary'

const Feedback = React.lazy(() => import('../templates/Feedback'))

const FlashFeedback = ({ feedback }) => {
  const [showFeedback, setShowFeedback] = useState(!!(feedback && feedback.type))

  if (!showFeedback) return null

  return (
    <Suspense fallback={<div />}>
      <Feedback onDismiss={() => setShowFeedback(false)} {...feedback} />
    </Suspense>
  )
}

const Navigation = ({ forceRefresh, feedback }) => {
  const {
    params: { orgId }
  } = useMatch('/(organisation|organisations)/:orgId/*', {
    end: false
  }) || { params: {} }

  const {
    params: { teamId }
  } = useMatch('/teams/:teamId/*', {
    end: false
  }) || { params: {} }

  const {
    params: { siteId }
  } = useMatch('/teams/:teamId/:siteId/*', {
    end: false
  }) || { params: {} }

  const {
    params: { uuid, shareToken }
  } = useMatch('/tests/:uuid/:shareToken/*', {
    end: false
  }) || { params: {} }

  const parsedOrgId = orgId === 'new' ? null : orgId
  const parsedSiteId = ['sites', 'team'].includes(siteId) ? null : siteId
  const parsedTeamId = teamId === 'new' ? null : teamId

  return (
    <>
      <PrimaryNavigation forceRefresh={forceRefresh} orgId={parsedOrgId} teamId={parsedTeamId} siteId={parsedSiteId} />
      <SecondaryNavigation
        orgId={parsedOrgId}
        teamId={parsedTeamId}
        siteId={parsedSiteId}
        uuid={uuid}
        shareToken={shareToken}
      />
      <FlashFeedback feedback={feedback} />
    </>
  )
}

export default Navigation
